// If we use useRoutes, we don't required to specify jsx elements, it takes js object for routing.
import { useRoutes } from 'react-router-dom';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import BmrRoutes from '../bmr/routes/BmrRoutes';
// import FormBuilderRoutes from '../form-builder/routes/FormBuilderRoutes';
// ==============================|| ROUTING RENDER ||============================== //
export default function ThemeRoutes() {
  // It will return a route tree for render valid react element.
  return useRoutes([LoginRoutes, MainRoutes, BmrRoutes]);
}